// @flow

import * as React from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { getStore } from '@ta/common.state';
import { localize, unescaped } from '@ta/common.i18n';

import type { InternalContentProps } from './base';
import { DefaultProps, defaultConnect } from './base';
import ReportIAPPanel from '../ReportIAPPanel';
import { ContentType } from '../submit/SubmitIapVote';

const ReportTripPanel = (props: InternalContentProps) => {
  const locale = getStore()
    .getState()
    .i18n.ietfLocale.replace('_', '-')
    .toLocaleLowerCase();
  const disagreementInfo = unescaped(
    localize('trip_level_2_disagree_or_error', {
      sUrl: `https://www.tripadvisorsupport.com/hc/${locale}/articles/360008024254`,
    }),
  );

  return (
    <ReportIAPPanel
      csrfToken={props.csrfToken}
      userId={props.userId}
      contentId={props.contentId}
      contentType={ContentType.TRIP}
      onError={props.onError}
      onComplete={props.onComplete}
      repostInfo={props.repostInfo}
    >
      {panel => (
        <React.Fragment>
          {panel.createRadioWithOptionalComment('PROFANE_EXPLICIT_HATE_SPEECH')}
          {panel.createRadioWithOptionalComment('PROMOTES_ILLEGAL_ACTIVITY')}
          {panel.createRadioWithOptionalComment('TRIP_COPYRIGHT')}
          {panel.createRadioWithOptionalComment('TRIP_NOT_TRAVEL_RELATED')}
          {panel.createRadioWithContentNoSubmit(
            'TRIP_ERROR_OR_DISAGREE',
            <span>{disagreementInfo}</span>,
          )}
          {panel.createRadioWithRequiredComment('OTHER')}
        </React.Fragment>
      )}
    </ReportIAPPanel>
  );
};
ReportTripPanel.defaultProps = DefaultProps;

// $FlowFixMe92
export default connect(state => defaultConnect(state))(ReportTripPanel);
